<template>

<a :href="link" target="_blank">
  <font-awesome-icon :icon=iconValue :size="size"/>
</a>

</template>

<script>
export default {
  name: 'SocialLink',
  props: {
    icon: String,
    size: String,
    link: String
  },
  computed: {
    iconValue: function() {
      return ['fab', this.icon]
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
